export const SMALL = 'small'
export const MEDIUM = 'medium'
export const LARGE = 'large'
export const FULL = 'full'
export default {
  SMALL,
  MEDIUM,
  LARGE,
  FULL,
}
